<template lang="pug">
main.pesquisa-inteligente
    .pesquisa-inteligente__barra-pesquisa
        i.el-icon-search

        input.pesquisa-inteligente__input(
            v-model='filtro',
            type='text',
            :placeholder='placeholderPais()',
            autocomplete='off',
            @keyup.enter='realizarPesquisa',
            @blur='fecharLista'
        )

    transition(name='el-zoom-in-top')
        ul.pesquisa-inteligente__ul(v-show='mostrarLista')
            .mb-2(v-for='opcao in opcoes')
                span.pesquisa-inteligente__categoria(
                    v-if='opcao.resultado.length'
                ) {{ internacionalizacaoCategoria(opcao.categoria) }}

                li(v-for='resultado in opcao.resultado')
                    span(@click='mapearAcao(resultado.id, opcao.codigo)') {{ resultado.valor }}
</template>

<script>
import TerritorioService from '@/services/TerritorioService';
import { mapState } from 'vuex';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'PesquisaInteligente',

    computed: {
        ...mapState(['usuarioLogado'])
    },

    data() {
        return {
            filtro: '',
            opcoes: [],
            mostrarLista: false,
            ambientes: AmbientesEmpresas
        };
    },

    methods: {
        async realizarPesquisa() {
            if (!this.filtro) return this.limpar();

            const { data } =
                await TerritorioService.realizarPesquisaInteligente(
                    this.filtro
                );
            this.opcoes = data;
            this.mostrarLista = true;

            const semResultado = !this.opcoes.filter(
                ({ resultado }) => resultado.length
            ).length;
            if (semResultado) {
                this.mostrarLista = false;
                this.$notify.warning({
                    message: this.$t('mensagens.menuSig.pesquisaInteligente.erro')
                });
            }
        },

        limpar() {
            this.items = [];
            this.filtro = '';
            this.mostrarLista = false;
        },

        fecharLista() {
            setTimeout(() => {
                this.mostrarLista = false;
            }, 300);
        },

        mapearAcao(id, tipo) {
            this.mostrarLista = false;
            switch (tipo) {
                case 'REPRESENTANTE':
                    this.$emit('representante-selecionado', id);
                    break;
                case 'TERRITORIO':
                    this.$emit('territorio-selecionado', id);
                    break;
                case 'MUNICIPIO':
                    this.$emit('municipio-selecionado', id);
                    break;
            }
        },

        internacionalizacaoCategoria(chave) {
            if (!chave) {
                return;
            }
            let chaveMaiuscula = chave.toUpperCase();
            chaveMaiuscula = chaveMaiuscula.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            chaveMaiuscula = chaveMaiuscula.replace(/\s+/g, '-');

            return this.$t(`mensagens.menuSig.pesquisaInteligente.categorias.${chaveMaiuscula}`);
        },

        placeholderPais() {
            if (this.usuarioLogado.paisGrupo === this.ambientes.PARAGUAY || this.usuarioLogado.paisGrupo === this.ambientes.NORTE_AMERICA) {
                return this.$t(`mensagens.menuSig.pesquisaInteligente.placeholderParaguai`);
            } else {
                return this.$t(`mensagens.menuSig.pesquisaInteligente.placeholder`);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.pesquisa-inteligente {
    width: 100%;
    height: 46px;
    border-radius: 5px;
    background: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}

.pesquisa-inteligente__input {
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    border-radius: 5px;
    color: var(--primary);
}

.pesquisa-inteligente__barra-pesquisa {
    height: 100%;
    display: flex;
    justify-content: center;

    i.el-icon-search {
        color: var(--primary);
        font-size: 25px;
        font-weight: bold;
        display: flex;
        align-items: center;
        margin: 0 8px;
    }
}

.pesquisa-inteligente__ul {
    list-style: none;
    padding: 8px 0 8px 24px;
    position: relative;
    z-index: 42;
    margin-top: 5px;
    border-radius: 5px;
    background-color: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

    li {
        padding-left: 18px;
        margin-top: 5px;
        cursor: pointer;
    }
}

.pesquisa-inteligente__categoria {
    font-weight: bold;
}

.pesquisa-inteligente__cadastro {
    display: flex;
}

.pesquisa-inteligente__btn-cadastro {
    border-radius: 20px !important;
}

em {
    background-color: var(--secondary);
}
</style>
